module.exports = __webpack_public_path__ + "static/media/banner_canon.bc3fbb55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_canon.jpg
// module id = 1028
// module chunks = 0